import { SOP_CLASS_UIDS } from '..';
import { getDataSet, readData } from './ReadECGData';
import { DrawECGCanvasClass } from './DrawECGCanvasClass';
/**
 * Load canvas and the canvas data.
 * @param {*} dataDICOMarrayBuffer DICOM DCM ECG Array Buffer.
 * @param {*} idView Draw ID View.
 * @param {*} nameView Identifier of the view you want to put, in case you have several views, default 0.
 */
export var initializeECGCanvas = function (_a) {
    var dataDICOMarrayBuffer = _a.dataDICOMarrayBuffer, channelsData = _a.channelsData, idView = _a.idView, nameView = _a.nameView, display = _a.display;
    return new Promise(function (resolve, reject) {
        try {
            //DataSet:
            var dataSet = getDataSet(dataDICOMarrayBuffer);
            //Read data from dataSet:
            var dataMg = readData(dataSet);
            var canvasId = idView + nameView;
            //Draw template:
            var ecgCanvas = new DrawECGCanvasClass(canvasId, dataMg, display, channelsData);
            //Draw compatible:
            switch (dataMg.sopClassUID) {
                case SOP_CLASS_UIDS.HemodynamicWaveformStorage: //Hemodynamic Waveform Storage
                    ecgCanvas.draw();
                    return resolve({ success: true, message: canvasId, canvasReference: ecgCanvas });
                case SOP_CLASS_UIDS.GeneralECGWaveformStorage: //General ECG Waveform Storage
                    ecgCanvas.draw();
                    return resolve({ success: true, message: canvasId, canvasReference: ecgCanvas });
                case SOP_CLASS_UIDS.Sop12LeadECGWaveformStorage: //12-lead ECG Waveform Storage
                    ecgCanvas.draw();
                    return resolve({ success: true, message: canvasId, canvasReference: ecgCanvas });
                case SOP_CLASS_UIDS.AmbulatoryECGWaveformStorage: //Ambulatory
                    ecgCanvas.drawNoCompatible();
                    return reject({ success: false, message: "Unsupported SOP Class UID: ".concat(dataMg.sopClassUID) });
                default:
                    ecgCanvas.drawNoCompatible();
                    return reject({ success: false, message: "Unsupported SOP Class UID: ".concat(dataMg.sopClassUID) });
            }
        }
        catch (error) {
            reject({ success: false, message: error });
        }
    });
};
//# sourceMappingURL=DicomECGViewer.js.map